import { defineComponent as _defineComponent } from 'vue'
import { reactive } from 'vue'
  import type { PropType } from 'vue'
  //@ts-ignore
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import useBreakpoint from '@/composables/useBreakpoint'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CarouselSwiper',
  props: {
    slidesPerView: {
      required: true,
      type: Number,
    },
    slidesPerGroup: {
      required: true,
      type: Number,
    },
    spaceBetween: {
      type: Number,
      default: 20,
    },
    swiperItems: {
      required: true,
      type: Array as PropType<any[]>,
    },
    navClass: {
      type: String,
      default: '',
    },
    breakPoints: {
      type: Object as PropType<{
        [key: string]: { slidesPerView: string; spaceBetween: string; slidesPerGroup: string }
      }>,
    },
  },
  setup(__props) {

const props = __props;

  

  const { isMobileDevice } = useBreakpoint()
  const swiperOptions = reactive({
    breakpoints: props.breakPoints,
    slidesPerView: props.slidesPerView,
    spaceBetween: props.spaceBetween,
    slidesPerGroup: props.slidesPerGroup,
    allowTouchMove: isMobileDevice.value,
    navigation: {
      prevEl: `.${props.navClass} .prev-nav-button`,
      nextEl: `.${props.navClass} .next-nav-button`,
    },
  })

return { __sfc: true,props, isMobileDevice, swiperOptions, reactive, swiper, swiperSlide, useBreakpoint }
}

})